import React from 'react';
import TechActionStatContainer from '../../containers/techActionStat/TechActionStatContainer';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';

const TechActionStatPage = () => {
  return (
    <>
      <BreadcrumbsContainer title="기술활동관리/기술활동현황" icon="partner" />
      <TechActionStatContainer />
    </>
  );
};

export default TechActionStatPage;
